var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounTowel557044906(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7242_13820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.773438,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#291482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.289 30.0269H12.2574C11.1986 30.0269 10.3359 29.1634 10.3359 28.0891V10.9124C10.3359 9.84465 11.1921 8.97461 12.2574 8.97461H27.289C28.3477 8.97461 29.2104 9.83806 29.2104 10.9124V28.0891C29.2039 29.1569 28.3477 30.0269 27.289 30.0269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7937,
    cy: 21.4324,
    rx: 5.27414,
    ry: 5.3191,
    fill: "white",
    stroke: "#291482",
    strokeWidth: 0.653549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7267 20.8845C14.7267 20.8845 17.2559 19.1445 19.5498 20.6341C22.9418 22.8355 24.5952 20.2122 24.5952 20.2122C24.5952 20.2122 25.8697 24.4372 21.8895 26.3091C21.8895 26.3091 18.7852 27.3571 16.1383 25.1029C16.1383 25.1095 14.7136 23.8044 14.7267 20.8845Z",
    fill: "#291482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7843 11.1016H22.5817C22.2484 11.1016 21.9805 11.3718 21.9805 11.708C21.9805 12.0441 22.2484 12.3143 22.5817 12.3143H23.7843C24.1176 12.3143 24.3855 12.0441 24.3855 11.708C24.3855 11.3718 24.1176 11.1016 23.7843 11.1016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9932 11.1016H25.7907C25.4574 11.1016 25.1895 11.3718 25.1895 11.708C25.1895 12.0441 25.4574 12.3143 25.7907 12.3143H26.9932C27.3266 12.3143 27.5945 12.0441 27.5945 11.708C27.5945 11.3718 27.3266 11.1016 26.9932 11.1016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3418,
    y: 13.2246,
    width: 18.8614,
    height: 1.46325,
    fill: "#291482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7777 12.3143H22.5817C22.2484 12.3143 21.9805 12.0441 21.9805 11.708C21.9805 11.3718 22.2484 11.1016 22.5817 11.1016H23.7777C24.111 11.1016 24.379 11.3718 24.379 11.708C24.379 12.0441 24.1045 12.3143 23.7777 12.3143Z",
    fill: "#291482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9945 12.3143H25.7985C25.4652 12.3143 25.1973 12.0441 25.1973 11.708C25.1973 11.3718 25.4652 11.1016 25.7985 11.1016H26.9945C27.3278 11.1016 27.5958 11.3718 27.5958 11.708C27.5958 12.0441 27.3278 12.3143 26.9945 12.3143Z",
    fill: "#291482"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7242_13820"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.773438,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounTowel557044906);
export default __webpack_public_path__ + "static/media/noun-towel-5570449-06.7308286b3c24e1690e260d7397649294.svg";
export { ForwardRef as ReactComponent };